<template>
  <div class="bigData-index">
    <dataTop :Width='Width'/>
    <div class="bigData-container clearfix">
      <dataLeft/>
      <dataRight/>
    </div>
  </div>
</template>

<script>
  import dataTop from "./components/dataTop";
  import dataLeft from "./components/dataLeft/dataLeft";
  import dataRight from "./components/dataRight/dataRight";

  export default {
    name: "bigData",
    components: {
      dataTop,
      dataLeft,
      dataRight,
    },
    data() {
      return {
        Width: 0,
      }
    },
    methods: {
      getWindowWidth() {
        this.Width = window.innerWidth
      },
    },
    created() {
    },
    mounted() {
      this.getWindowWidth()
      window.addEventListener('resize', this.getWindowWidth)
      this.$nextTick(function () {
        $("body")
            .removeClass("app")
            .addClass("bigData");
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth)
    }
  }
</script>

<style scoped lang="scss">
  .bigData-index {
    padding: 0 15px 15px;
    background-color: #061033;
    min-height: 100vh;
    width: 100%;
  }
  @media screen and (max-width: 1920px) {
    .bigData-container {
      width: 1366px;
      margin: 0 auto;
    }
  }
  @media screen and (min-width: 1903px) {
    .bigData-container {
      width: 100%;
      margin: 0 auto;
    }
  }
</style>
